import { render, staticRenderFns } from "./FormsCacheableForm.vue?vue&type=template&id=056ffc18&"
import script from "./FormsCacheableForm.vue?vue&type=script&lang=js&"
export * from "./FormsCacheableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports